
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { ClientApi, IdName as Position } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = { name: string };
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class PositionForm extends FormMixin {
  @Prop({ type: Object }) position?: Position;
  formName = "役職";
  formValues: FormValues = {
    name: ""
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "役職名" }))
    });
  }
  beforeMount() {
    this.formValues = this.position
      ? {
          name: this.position.name
        }
      : { name: "" };
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      if (this.position) {
        await new ClientApi().updatePosition({
          positionId: this.position!.id,
          createPositionRequest: values
        });
      } else {
        await new ClientApi().createPosition({
          createPositionRequest: values
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new ClientApi().deletePosition({
        positionId: this.position!.id
      });
    });
  }
}
